import { AuthConfig } from "angular-oauth2-oidc";

export const authConfig: AuthConfig = {
  clientId: 'oqnZQTj3qAHGqXyK43OYH',
  issuer: 'https://interno-davinci-account-prod.uc.r.appspot.com/',
  redirectUri: window.location.origin + '/',
  silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',
  responseType: 'code',
  scope: 'openid profile email offline_access api',
  useSilentRefresh: true, // Needed for Code Flow to suggest using iframe-based refreshes
  silentRefreshTimeout: 600000, // For faster testing
  timeoutFactor: 0.75, // For faster testing
  showDebugInformation: true,
  sessionChecksEnabled: true,
};

export const environment = {
  urlBackend: 'https://actividades.davincitech.co/api',
  production: true,
  authConfig,
  urlBackendAccount: 'https://gestion-dot-interno-davinci-account-prod.uc.r.appspot.com/api', 
};